var _mask, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWidgetScatter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "8ysri2naaa",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-4 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-4 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    fill: "#535353"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5v2a2 2 0 0 0 2-2h-2zm0 0h2a2 2 0 0 0-2-2v2zm0 0V3a2 2 0 0 0-2 2h2zm0 0h-2a2 2 0 0 0 2 2V5zm-4 2v2a2 2 0 0 0 2-2h-2zm0 0h2a2 2 0 0 0-2-2v2zm0 0V5a2 2 0 0 0-2 2h2zm0 0h-2a2 2 0 0 0 2 2V7z",
    fill: "#535353",
    mask: "url(#8ysri2naaa)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0z",
    fill: "#535353"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 10a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0z",
    fill: "#535353",
    stroke: "#535353"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14h8.5a.5.5 0 0 0 .5-.5v-7",
    stroke: "#535353",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetScatter);
export default __webpack_public_path__ + "static/media/widgetScatter.caf63771030e45a45a7d6fc5be49b30c.svg";
export { ForwardRef as ReactComponent };